import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Box, Image, Text } from "@0xsequence/design-system";

import { configureLogger } from "@0xsequence/utils";


import Button from "../Utils/Button/Button";
import "./Navbar.css";

import { useContext, useEffect, useState } from "react";

import profile from "../../assets/images/image/profile.svg";
import profileN from "../../assets/images/profile.png";

import GlobalContext from "../../Contexts/GlobalContext";
import assets from "../../assets/images";
import { useWalletClient, usePublicClient, useAccount, useConnect, useDisconnect } from 'wagmi'
import { ConnectButton, useAccountModal } from "@rainbow-me/rainbowkit";

import ButtonConnect from "../Utils/Button/ButtonConnect";
import { sequence } from "0xsequence";

const Navbar = () => {
  const { connect, connectors, isLoading, pendingConnector} = useConnect()
  const { openAccountModal } = useAccountModal();
  const { disconnect } = useDisconnect();
  const {
    // address,
    // isConnected,
    // connect,
    getWalletInfo,
    handleDisconnect,
    isConnecting,
    minted,
    isclaimed,
     setMuted, audioRef,isMuted
  } = useContext(GlobalContext);
  const Disconnect = () => {
    var wallet = localStorage.getItem("wagmi.wallet");

    if (wallet === "metaMask") {
      disconnect();
    } else {
      // openAccountModal()
      disconnect();
    }
    window.location.reload();
  };

  const { isConnected, address } = useAccount();
  const publicClient = usePublicClient();
  const { data: walletClient } = useWalletClient();
  const [consoleMsg, setConsoleMsg] = useState(null);
  const [consoleLoading, setConsoleLoading] = useState(false);
  const [web3Available, setWeb3Available] = useState(false);
  const handleShareButtonClick = () => {
    // const shareUrl = `https://www.instagram.com/sharer.php?u=https://cdn.pixabay.com/photo/2016/10/26/19/00/domain-names-1772242_1280.jpg`;
    // window.open(shareUrl, '_blank');
  };
  const NavigartionView = () => {
    if (minted && isclaimed) {
      return (
        <li>
          <Link to="https://www.celio.in/#category02658" target="_blank">
            Visit Celio
          </Link>
        </li>
      );
    } else if (minted) {
      return (
        <li>
          <Link to="/claim-coupon">Claim Coupon</Link>
        </li>
      );
    } else {
      return (
        <li>
          <Link to="/claim">Claim collectible</Link>
        </li>
      );
    }
  };

  useEffect(() => {
    NavigartionView();
    if (typeof window.ethereum !== "undefined") {
      setWeb3Available(true);
    } else {
      setWeb3Available(false);
    }
  }, [minted, isclaimed]);

  const toggleMute = () => {
    setMuted(!isMuted)
    localStorage.setItem("mute", !isMuted);

  };

  return (
    <nav>
      <div className="logo">
        <HashLink smooth to="/#">
          <img src={assets.logos.celioLogo} alt="" className="desktoplogo" />
          <img src={assets.logos.celioLogo} alt="" className="mobilelogo" />
        </HashLink>
      </div>
      <div className="nav__container">
        <ul className="mainnav">
          {NavigartionView()}

          <li>
            <HashLink smooth to="/#view-collections">
              View Collections
            </HashLink>
          </li>
          <li>
            <Link to="http://celioverse.layer-e.com/" target="_blank">
              Celioverse
            </Link>
          </li>
        </ul>
        <ul className="mainnav">
        <div className="muted" >
        {
          isMuted ?
        <img src= {assets.logos.mute} alt="" onClick={()=> toggleMute()} />


          :
        <img src= {assets.logos.unmute} alt="" onClick={()=> toggleMute()} />

        }
       
        
        </div>
          {isConnected ? (
            <div className="isConnected">
              <div className="profile">
                <div className="profileicon">
                  {minted ? (
                    <img src={profile} alt="" />
                  ) : (
                    <img src={profileN} alt="" />
                  )}
                  {isclaimed ? <div className="climedStatus">1</div> : null}
                </div>
                <div className="ProfileInfo">
                  <div className="profile__info">
                    <div className="innerbox">
                      <div className="user_details_box">
                        <div className="img">
                          {minted ? (
                            <img src={profile} alt="" />
                          ) : (
                            <img src={profileN} alt="" />
                          )}
                        </div>
                        <div className="wallet_details">
                          <div className="wallet">
                            <b
                              className="adresscopy"
                              onClick={() => {
                                navigator.clipboard.writeText(address);
                              }}
                            >
                              {address?.slice(0, 4)}...
                              {address?.slice(address?.length - 5)}
                            </b>
                          </div>
                          <div className="small">Click here to copy</div>
                        </div>
                      </div>

                      {minted ? (
                        <Link to="/mycollectibles">
                          <div
                            className="eachItems"
                            onClick={() => handleShareButtonClick()}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 12C9.53043 12 10.0391 11.7893 10.4142 11.4142C10.7893 11.0391 11 10.5304 11 10C11 9.46957 10.7893 8.96086 10.4142 8.58579C10.0391 8.21071 9.53043 8 9 8C8.46957 8 7.96086 8.21071 7.58579 8.58579C7.21071 8.96086 7 9.46957 7 10C7 10.5304 7.21071 11.0391 7.58579 11.4142C7.96086 11.7893 8.46957 12 9 12ZM21.5 6.90359C21.5 6.6538 21.3669 6.42294 21.1507 6.29779L12.3507 1.20305C12.1338 1.07745 11.8662 1.07745 11.6493 1.20305L2.84927 6.29779C2.6331 6.42294 2.5 6.6538 2.5 6.90359V17.0964C2.5 17.3462 2.6331 17.5771 2.84927 17.7022L11.6493 22.7969C11.8662 22.9226 12.1338 22.9226 12.3507 22.7969L21.1507 17.7022C21.3669 17.5771 21.5 17.3462 21.5 17.0964V6.90359ZM11.6493 3.51404C11.8662 3.38845 12.1338 3.38845 12.3507 3.51404L19.1507 7.45079C19.3669 7.57594 19.5 7.8068 19.5 8.05659V13.2969C19.5 13.841 18.9065 14.1771 18.44 13.8973L15.3416 12.039C15.0975 11.8927 14.7892 11.9086 14.5615 12.0793L7.33719 17.4974C7.1127 17.6657 6.80938 17.6838 6.56652 17.5432L4.84932 16.5492C4.63312 16.4241 4.5 16.1932 4.5 15.9434V8.05659C4.5 7.8068 4.63311 7.57594 4.84928 7.45079L11.6493 3.51404ZM12.3507 20.486C12.1338 20.6116 11.8662 20.6115 11.6493 20.4859L9.76432 19.3945C9.33004 19.1431 9.29363 18.5298 9.6951 18.2287L14.6855 14.4863C14.9132 14.3156 15.2215 14.2997 15.4656 14.4461L18.0413 15.991C18.4987 16.2653 18.4935 16.9299 18.032 17.1971L12.3507 20.486Z"
                                fill="#E0E0E0"
                              />
                            </svg>

                            <div className="Nav_title">My collectibles</div>
                          </div>
                        </Link>
                      ) : null}
                      {isclaimed ? (
                        <Link to="/coupons">
                          <div className="eachItems">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 4C19.7652 3.99996 20.5015 4.29233 21.0583 4.81728C21.615 5.34224 21.9501 6.06011 21.995 6.824L22 7V8.817C21.9977 9.08708 21.925 9.35189 21.7888 9.58518C21.6527 9.81847 21.458 10.0121 21.224 10.147L21.117 10.205C20.7935 10.3638 20.5189 10.6071 20.3222 10.9091C20.1256 11.2111 20.0142 11.5607 19.9998 11.9208C19.9855 12.2809 20.0687 12.6382 20.2407 12.9549C20.4127 13.2716 20.6671 13.536 20.977 13.72L21.117 13.795C21.55 14.009 21.937 14.451 21.993 15.035L22 15.183V17C22 17.7652 21.7077 18.5015 21.1827 19.0583C20.6578 19.615 19.9399 19.9501 19.176 19.995L19 20H5C4.23479 20 3.49849 19.7077 2.94174 19.1827C2.38499 18.6578 2.04989 17.9399 2.005 17.176L2 17V15.183C2 14.577 2.352 14.105 2.776 13.853L2.883 13.795C3.20653 13.6362 3.48114 13.3929 3.67779 13.0909C3.87445 12.7889 3.98583 12.4393 4.00017 12.0792C4.01452 11.7191 3.93129 11.3618 3.75928 11.0451C3.58727 10.7284 3.33288 10.464 3.023 10.28L2.883 10.205C2.45 9.991 2.063 9.549 2.007 8.965L2 8.818V7C1.99996 6.23479 2.29233 5.49849 2.81728 4.94174C3.34224 4.38499 4.06011 4.04989 4.824 4.005L5 4H19ZM19 6H5C4.75507 6.00003 4.51866 6.08996 4.33563 6.25272C4.15259 6.41547 4.03566 6.63975 4.007 6.883L4 7V8.535C4.59268 8.8766 5.08783 9.36453 5.43809 9.95214C5.78836 10.5397 5.98203 11.2074 6.00059 11.8912C6.01915 12.575 5.86198 13.2522 5.5441 13.8579C5.22623 14.4637 4.75828 14.9778 4.185 15.351L4 15.465V17C4.00003 17.2449 4.08996 17.4813 4.25272 17.6644C4.41547 17.8474 4.63975 17.9643 4.883 17.993L5 18H19C19.2449 18 19.4813 17.91 19.6644 17.7473C19.8474 17.5845 19.9643 17.3603 19.993 17.117L20 17V15.465C19.4073 15.1234 18.9122 14.6355 18.5619 14.0479C18.2116 13.4603 18.018 12.7926 17.9994 12.1088C17.9809 11.425 18.138 10.7478 18.4559 10.1421C18.7738 9.53632 19.2417 9.02225 19.815 8.649L20 8.535V7C20 6.75507 19.91 6.51866 19.7473 6.33563C19.5845 6.15259 19.3603 6.03566 19.117 6.007L19 6ZM10 9C10.2449 9.00003 10.4813 9.08996 10.6644 9.25272C10.8474 9.41547 10.9643 9.63975 10.993 9.883L11 10V14C10.9997 14.2549 10.9021 14.5 10.7272 14.6854C10.5522 14.8707 10.313 14.9822 10.0586 14.9972C9.80416 15.0121 9.55362 14.9293 9.35817 14.7657C9.16271 14.6021 9.0371 14.3701 9.007 14.117L9 14V10C9 9.73478 9.10536 9.48043 9.29289 9.29289C9.48043 9.10536 9.73478 9 10 9Z"
                                fill="#E0E0E0"
                              />
                            </svg>

                            <div className="Nav_title">
                              Active Coupons
                              <div className="redCond">1</div>
                            </div>
                          </div>
                        </Link>
                      ) : null}

                      {/*}  // <div
                      //   className="eachItems"
                      //   onClick={() => getWalletInfo()}
                      // >
                      //   <svg
                      //     width="24"
                      //     height="24"
                      //     viewBox="0 0 24 24"
                      //     fill="none"
                      //     xmlns="http://www.w3.org/2000/svg"
                      //   >
                      //     <path
                      //       d="M16 13.5C16.4333 13.5 16.7917 13.3583 17.075 13.075C17.3583 12.7917 17.5 12.4333 17.5 12C17.5 11.5667 17.3583 11.2083 17.075 10.925C16.7917 10.6417 16.4333 10.5 16 10.5C15.5667 10.5 15.2083 10.6417 14.925 10.925C14.6417 11.2083 14.5 11.5667 14.5 12C14.5 12.4333 14.6417 12.7917 14.925 13.075C15.2083 13.3583 15.5667 13.5 16 13.5ZM5 21C4.45 21 3.979 20.804 3.587 20.412C3.195 20.02 2.99934 19.5493 3 19V5C3 4.45 3.196 3.979 3.588 3.587C3.98 3.195 4.45067 2.99934 5 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V7.5H19V5H5V19H19V16.5H21V19C21 19.55 20.804 20.021 20.412 20.413C20.02 20.805 19.5493 21.0007 19 21H5ZM13 17C12.45 17 11.979 16.804 11.587 16.412C11.195 16.02 10.9993 15.5493 11 15V9C11 8.45 11.196 7.979 11.588 7.587C11.98 7.195 12.4507 6.99934 13 7H20C20.55 7 21.021 7.196 21.413 7.588C21.805 7.98 22.0007 8.45067 22 9V15C22 15.55 21.804 16.021 21.412 16.413C21.02 16.805 20.5493 17.0007 20 17H13ZM20 15V9H13V15H20Z"
                      //       fill="#E0E0E0"
                      //     />
                      //   </svg>

                      //   <div className="Nav_title">Get wallet Info</div>
                      // </div>
                      */}
                    </div>

                    <div className="disconnect">
                      <Button text={"Sign Out"} click={Disconnect} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : isConnecting ? (
            <Button loader={true} />
          ) : (
            <div className="connect">
            
                <ConnectButton.Custom>
                  {({
                    account,
                    chain,
                    openAccountModal,
                    openChainModal,
                    openConnectModal,
                    authenticationStatus,
                    mounted,
                  }) => {
                    const ready = mounted && authenticationStatus !== "loading";
                    const connected =
                      ready &&
                      account &&
                      chain &&
                      (!authenticationStatus ||
                        authenticationStatus === "authenticated");

                    return (
                      <div
                        {...(!ready && {
                          "aria-hidden": true,
                          style: {
                            opacity: 0,
                            pointerEvents: "none",
                            userSelect: "none",
                          },
                        })}
                      >
                        {(() => {
                          if (!connected) {
                            return (
                              <ButtonConnect
                                onClick={openConnectModal}
                                type="button"
                              >
                                Sign In
                              </ButtonConnect>
                            );
                          }

                          if (chain.unsupported) {
                            return (
                              <ButtonConnect
                                onClick={openChainModal}
                                type="button"
                              >
                                Wrong network
                              </ButtonConnect>
                            );
                          }

                          return (
                            <div style={{ display: "flex", gap: 12 }}>
                              <button
                                onClick={openChainModal}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                type="button"
                              >
                                {chain.hasIcon && (
                                  <div
                                    style={{
                                      background: chain.iconBackground,
                                      width: 12,
                                      height: 12,
                                      borderRadius: 999,
                                      overflow: "hidden",
                                      marginRight: 4,
                                    }}
                                  >
                                    {chain.iconUrl && (
                                      <img
                                        alt={chain.name ?? "Chain icon"}
                                        src={chain.iconUrl}
                                        style={{ width: 12, height: 12 }}
                                      />
                                    )}
                                  </div>
                                )}
                                {chain.name}
                              </button>

                              <button onClick={openAccountModal} type="button">
                                {account.displayName}
                                {account.displayBalance
                                  ? ` (${account.displayBalance})`
                                  : ""}
                              </button>
                            </div>
                          );
                        })()}
                      </div>
                    );
                  }}
                </ConnectButton.Custom>
            
            </div>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
